import axios from 'axios'

axios.defaults.baseURL = 'https://api.emailable.com/v1'

interface EmailableResponse {
  email: string
  state: string
  reason?: string
}

export const useEmailable = () => {
  const runtimeConfig = useRuntimeConfig()
  const API_KEY = runtimeConfig.public.emailable.apiKey

  const isLoading = ref(false)
  const response = ref<EmailableResponse | null>(null)

  const isEmailUndeliverable = computed(() => {
    if (!response) {
      return false
    }
    return response.value?.state === 'undeliverable'
  })

  const errorMessage = computed(() => {
    if (isEmailUndeliverable.value) {
      return `Cet email semble incorrect : ${response.value?.reason}`
    }
    return null
  })

  const verifyEmail = async (email: string) => {
    if (runtimeConfig.public.emailable.enabled !== 'true') {
      return
    }

    if (email === response?.value?.email) {
      return
    }

    isLoading.value = true

    try {
      const { data } = await axios.get('/verify', {
        params: {
          email,
          api_key: API_KEY,
        },
      })
      response.value = data
    } catch (error: any) {
      console.error(error.response?.data || error)
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    errorMessage,
    isEmailUndeliverable,
    verifyEmail,
  }
}
